import script from "./SimbadResolver.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimbadResolver.vue?vue&type=script&lang=ts&setup=true"

import "./SimbadResolver.vue?vue&type=style&index=0&id=3d0c955a&lang=css"

const __exports__ = script;

export default __exports__